import { render, staticRenderFns } from "./CourseAllPanel.vue?vue&type=template&id=954a5468&scoped=true"
import script from "./CourseAllPanel.vue?vue&type=script&lang=js"
export * from "./CourseAllPanel.vue?vue&type=script&lang=js"
import style0 from "./CourseAllPanel.vue?vue&type=style&index=0&id=954a5468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954a5468",
  null
  
)

export default component.exports